// @flow
import type { Node } from 'react';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import BackgroundColor from 'components/common/BackgroundColor';
import Responsive from 'components/common/Responsive';

import './RegisterTemplate.scss';

type Props = {
  form: Node,
};

class RegisterTemplate extends Component<Props> {
  render() {
    const { form } = this.props;
    return (
      <div className="RegisterTemplate">
        <Helmet>
          <title>회원가입 | 캐시바이</title>
        </Helmet>
        <BackgroundColor color="#ffffff" />
        <Responsive className="mock-header">
          <Link to="/" className="brand">
            <img src="https://images.cacheby.com/logo.svg" alt="CacheBy" />
          </Link>
        </Responsive>
        <section className="rest">
          <div className="register-card">{form}</div>
        </section>
      </div>
    );
  }
}

export default RegisterTemplate;



// WEBPACK FOOTER //
// ./src/components/register/RegisterTemplate/RegisterTemplate.js